import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'sm-pdf-preview-modal',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, TranslateModule],
  templateUrl: './pdf-preview-modal.component.html',
  styleUrl: './pdf-preview-modal.component.scss',
})
export class PdfPreviewModalComponent {
  @Input() visible = false;
  @Input() pdfBase64 = '';
  @Input() filename = '';
  @Output() visibleChange = new EventEmitter<boolean>();

  private cachedPdfUrl: SafeResourceUrl | null = null;
  private currentPdfBase64 = '';

  constructor(private sanitizer: DomSanitizer) {}

  get pdfUrl(): SafeResourceUrl {
    if (!this.pdfBase64) return '';
    if (this.cachedPdfUrl && this.currentPdfBase64 === this.pdfBase64) {
      return this.cachedPdfUrl;
    }
    this.currentPdfBase64 = this.pdfBase64;
    const dataUrl = `data:application/pdf;base64,${this.pdfBase64}`;
    this.cachedPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(dataUrl);
    return this.cachedPdfUrl;
  }

  onHide() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  downloadPdf() {
    if (!this.pdfBase64 || !this.filename) return;

    const byteCharacters = atob(this.pdfBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = this.filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}
